import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-section-footer',
  templateUrl: './section-footer.component.html',
  styleUrls: ['./section-footer.component.scss']
})
export class SectionFooterComponent implements OnInit {
  @Input() classes = 'background-light cream-light-bg';
  @Input() buttonText: string;
  @Input() buttonUrl: string;
  @Input() buttonParams: any;
  @Input() buttonClass = 'btn-secondary1';

  constructor() { }

  ngOnInit() {
  }

  goto(href) {
    // console.log('goto', href);
    window.open(href, '_blank');
  }
}
